import type { CustomCellEditorProps } from '../react.js';
import { type ChangeEvent } from 'react';

import {
  Input,
  InputWithCounter,
  type InputProps,
} from '@mint-lib/tw-components';

import { useStartFromEventKey } from '../hooks/useStartFromEventKey.js';

export interface TextEditorProps extends CustomCellEditorProps {
  /**
   * Additional props to be passed to the input
   */
  InputProps?: Omit<InputProps, 'value' | 'onChange' | 'onBlur'>;
}

export const TextEditor = (props: TextEditorProps) => {
  const { value, onValueChange, InputProps, eventKey } = props;

  const inputValue = value ?? '';

  useStartFromEventKey(eventKey, value, onValueChange);

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    onValueChange(e.target.value);
  };

  if (InputProps?.maxLength) {
    return (
      <InputWithCounter
        type="text"
        value={inputValue}
        onChange={handleChange}
        size="small"
        autoFocus
        className="[&>input]:w-full [&>input]:border-none [&>input]:focus:outline-none"
        aria-label="text-editor"
        data-dd-action-name="Grid cell: edit text"
        maxLength={InputProps.maxLength}
        {...InputProps}
      />
    );
  }

  return (
    <Input
      type="text"
      value={inputValue}
      onChange={handleChange}
      size="small"
      autoFocus
      className="w-full border-none focus:outline-none"
      aria-label="text-editor"
      data-dd-action-name="Grid cell: edit text"
      {...InputProps}
    />
  );
};
